import React, { FC } from 'react'
import Image from "next/legacy/image"
import s from './Teaser.module.css'
import Link from 'next/link'
import { Button } from '@components/ui'

interface TeaserProps {
  className?: string
  title: string
  text: string
  colorLight: string
  cta?: string
  url: string,
  image: any
}

const Teaser: FC<TeaserProps> = ({ title, text, cta, url, image, colorLight }) => {

  return (
    <div className={s.root}>
      <Link href={url} legacyBehavior passHref>
        <div className={'cursor-pointer'}>
          <div className='sm:block aspect-w-12 lg:aspect-w-16 aspect-h-16 lg:aspect-h-8 rounded-cornerS overflow-hidden'>
            {image &&
              <Image
                priority={false} loading="lazy"
                className={s.image}
                alt='Teaser image'
                src={image}
                layout='fill'
                objectFit='cover' />}
          </div>
          <div className='absolute right-4 left-4 md:right-0 md:left-0 top-50p md:w-full mx-auto max-w-xl'>
            <div className={s.body}>
              <h1 style={{
                color: colorLight
              }} className={`text-primary200 ${s.title}`}>{title}</h1>
              <div className='text-center mt-10'>
                {url && <div className={s.teaserWrapper}>
                  <Button style={{
                    backgroundColor: colorLight
                  }} className={s.teaser} Component='a' variant='primaryMedium'>{cta}</Button>
                </div>}
              </div>
            </div>
          </div>
        </div>
        {/*<h2 className={`absolute font-sans antialiased top-24 md:top-32 left-0 right-0 z-10 font-light ${s.title}`}>{headline}</h2>*/}
      </Link>
    </div>
  )
}
export default Teaser
